import type { VoidComponent } from "solid-js";

type DropZoneProps = {
  active: boolean;
};

const DropZone: VoidComponent<DropZoneProps> = (props) => (
  <div classList={{ "border-b-2 border-drop": props.active }} />
);

export default DropZone;
